module.exports = __webpack_public_path__ + "img/tag.3d988519.png";